import request from '../../utils/request'

// 风险小游戏问题获取
const risk = () => {
  return request({
      url: process.env.VUE_APP_API + `game/risk/content`,
      method: 'get',
  })
}
export {
  risk
}